exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-8223aa76] {\n  max-width: 500px;\n}\n.member-code[data-v-8223aa76] {\n  font-size: 11px;\n  color: #666;\n}\n", ""]);

// exports
